import { PATH, PATH_ADMIN } from './path'

export const PRIVAT_INITIAL_ROUTE = `/${PATH.DASHBOARD}`
export const PRIVAT_ADMIN_INITIAL_ROUTE = `/${PATH.ADMIN}/${PATH_ADMIN.USERS}`
